import { render, staticRenderFns } from "./classifier.vue?vue&type=template&id=d5c2504a&"
import script from "./classifier.vue?vue&type=script&lang=ts&"
export * from "./classifier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports